import {Directive, forwardRef, Input} from '@angular/core';
import {FormControl, NG_VALIDATORS, Validator} from '@angular/forms';

@Directive({
    selector: '[lvWertemengeValidator]',
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => WertemengeValidatorDirective),
        },
    ],
    standalone: false
})
export class WertemengeValidatorDirective implements Validator {

  @Input()
  selectedOptionProvider: () => string;

  validate(control: FormControl): {} {
    if (control.value === '' || this.selectedOptionProvider() === control.value) {
      return null;
    }
    return {ERROR: 'ERRORS.INVALID'};
  }
}
